import React, { Component } from 'react'

class NamesView extends Component {

    render() {
        let names = this.props.namesInfo;
        if (!names) {
            return null;
        }

        return (
            <div>
                <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Фамилия</label>
                        <div className="form-element-data date">
                            <div className="form-element-data-text">
                                <p>{names.lastName}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Имя</label>
                        <div className="form-element-data date">
                            <div className="form-element-data-text">
                                <p>{names.firstName}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {names.middleName && <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Отчество</label>
                        <div className="form-element-data">
                            <div className="form-element-data-text">
                                <p>{names.middleName}</p>
                            </div>
                        </div>
                    </div>
                </div>}

            </div>
        )
    }
}

export default NamesView
